import { render } from "./FirstSteps.vue?vue&type=template&id=2559f112&scoped=true&lang=pug"
import script from "./FirstSteps.vue?vue&type=script&setup=true&lang=js"
export * from "./FirstSteps.vue?vue&type=script&setup=true&lang=js"

import "./FirstSteps.vue?vue&type=style&index=0&id=2559f112&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2559f112"]])

export default __exports__